export function PlanSwitchSuccess() {
  return (
    <div className="inline-flex h-full w-full flex-col items-center gap-6 overflow-hidden rounded-lg p-6 py-16 outline-1 -outline-offset-1 outline-edge-light outline-solid">
      {/* Icon */}
      <div className="flex h-10 w-10 items-center justify-center rounded-full bg-tag-green-primary outline-2 outline-edge-light outline-solid">
        {/* Check mark */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5 text-[#D5E6DC]"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={3}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M5 13l4 4L19 7"
          />
        </svg>
      </div>

      {/* Title */}
      <h2 className="text-center font-archivo text-2xl leading-[26px] font-semibold text-[#323232]">
        Plan interval switched successfully!
      </h2>

      {/* Subtitle */}
      <p className="max-w-lg text-center font-archivo text-xl leading-7 font-normal text-[#323232]">
        Enjoy the services now at a discounted rate
      </p>
    </div>
  );
}
